import React, { useEffect, useState } from "react";
import axios from "axios";
import { Radio } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LiveQueueBadge({ appointment }) {
  const [q, setQ] = useState(null);
  useEffect(() => {
    let timer;
    const load = () => axios.get(`${API}/queue/status`, { params: { booking_id: appointment.id, email: appointment.patient_email } }).then((r) => setQ(r.data)).catch(() => {});
    load();
    timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, [appointment.id, appointment.patient_email]);

  if (!q) return null;
  const done = ["Completed", "No-Show", "Cancelled"].includes(q.status);
  return (
    <div data-testid={`live-queue-${appointment.id}`} className={`mt-2 p-2.5 rounded-xl text-[11px] flex flex-wrap items-center gap-x-3 gap-y-1 ${q.status === "In Consultation" ? "bg-emerald-50 border border-emerald-200 text-emerald-900" : "bg-[#EBF4F1] border border-emerald-100 text-[#0D3B2E]"}`}>
      <span className="inline-flex items-center gap-1 font-bold"><Radio className="w-3 h-3 text-rose-500 animate-pulse" /> Live queue</span>
      <span>Your token <b>#{q.token_no}</b></span>
      <span>Now serving <b>{q.now_serving_token ? `#${q.now_serving_token}` : "—"}</b></span>
      {!done && q.status !== "In Consultation" && <span><b>{q.patients_ahead}</b> ahead{q.estimated_wait_minutes != null ? ` · ~${q.estimated_wait_minutes} min` : ""}</span>}
      {q.status === "In Consultation" && <span className="font-bold">It's your turn — please go in</span>}
      {done && <span className="font-semibold">{q.status}</span>}
    </div>
  );
}
